module.exports = __webpack_public_path__ + "img/arrows-expand.f493340c.svg";